<template>
	<div>
		<div class="permissionTool">
			<el-input size="small" :placeholder="this.$t('permissionmanage.hint1')" style="width:350px"  v-model="role.name">
				<template slot="prepend">{{$t('permissionmanage.role')}}</template>
			</el-input>
			<el-input size="small" :placeholder="this.$t('permissionmanage.hint2')" v-model="role.roleName">
			</el-input>
			<el-button type="primary" size="small" icon="el-icon-plus" @click="insertRole()">{{$t('permissionmanage.newrole')}}</el-button>
		</div>

		<div style="margin-top: 20px; width: 720px;">
			<el-collapse accordion @change="change" v-model="activeName">
				<el-collapse-item :title="role.roleName" :name="role.id" v-for="(role,index) in roles" :key="index">
					<el-card class="box-card">
						<div slot="header" class="clearfix">
							<span>{{$t('permissionmanage.span1')}}</span>
							<el-button style="float: right; padding: 3px 0; color: red;" type="text"
								icon="el-icon-delete" @click="deleteRole(role.id)"></el-button>
						</div>
						<div>
							<el-tree ref="tree" node-key="id" :key="index" :default-checked-keys="selectedMenus" show-checkbox
								:data="allMenus" :props="defaultProps"></el-tree>
							<div style="display: flex; justify-content: flex-end; margin-top: 4px;">
								<el-button size="small" @click="cancel()">{{$t('permissionmanage.cancelmodify')}}</el-button>
								<el-button size="small" type="primary" @click="doUpdate(role.id,index)">{{$t('permissionmanage.confirmmodify')}}</el-button>
							</div>
						</div>
					</el-card>
				</el-collapse-item>

			</el-collapse>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		components: {

		},
		data() {
			return {
				role: {
					name: '',
					roleName: '',
				},
				roles: [],
				allMenus: [],
				defaultProps: {
					children: 'children',
					label: 'name'
				},
				selectedMenus: [],
				activeName: -1
			};
		},
		created() {
			this.reload();
		},
		methods: {
			change(roleId) {
				// 当打开时，初始化菜单
				if (roleId) {
					this.getAllMenus();
					this.getMenuIdsByRoleId(roleId)
				} else {
					this.selectedMenus = [100];
				}
			},
			reload() {
				let that = this;
				that.getRequest('/tpa-api/admin/getAllRoles', null).then(
					resp => {
						if (resp) {
							that.roles = resp.result;
						}
					});
			},
			getAllMenus() {
				this.getRequest('/tpa-api/menu/getAllMenus', null).then(
					resp => {
						if (resp) {
							this.allMenus = resp.result;
							console.log('获得的menu为：', this.allMenus);
						}
					});
			},
			getMenuIdsByRoleId(roleId) {
				this.getRequest('/tpa-api/menu/getMenuIdsByRoleId?roleId=' + roleId, null).then(
					resp => {
						if (resp) {
							this.selectedMenus = resp.result;
						}
					});
			},
			doUpdate(roleId, index) {
				// 获取到tree的数组 通过index获取到当前选中的树
				let tree = this.$refs.tree[index];
				let selectKeys = tree.getCheckedKeys(true);
				let data = {
					roleId: roleId,
					menuIds: selectKeys
				}
				this.putRequest('/tpa-api/menu/updateMenuRole', data).then(resp => {
					if (resp) {
						this.reload();
					}
				})
			},
			cancel() {
				this.activeName = -1
			},
			insertRole() {
				let name = this.role.name;
				let roleName = this.role.roleName;
				if (name == '' || roleName == '') {
					this.$message({
						message: this.$t('notification.permissionmanagemessage2'),
						type: 'warning'
					});
					return;
				}
				let data = {
					name: this.role.name,
					roleName: this.role.roleName
				}
				this.postRequest('/tpa-api/menu/insertRole', data).then(resp => {
					if (resp) {
						this.role = {};
						this.reload();
					}
				})
			},
			deleteRole(roleId) {
				this.$confirm(this.$t('notification.permissionmanagemessage'), this.$t('notification.title'), {
					confirmButtonText: this.$t('notification.confirm'),
					cancelButtonText: this.$t('notification.cancel'),
					type: 'warning'
				}).then(() => {
					this.deleteRequest('/tpa-api/menu/deleteRole/'+roleId,null).then(resp=>{
						if(resp){
							that.page=1;
							that.length = 5;
							this.reload();
						}
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: this.$t('notification.cancelinfo')
					});
				});

			}
		},
	};
</script>

<style>
	.permissionTool {
		display: flex;
		justify-content: flex-start;
	}

	.permissionTool .el-input {
		width: 300px;
		margin-right: 8px;

	}
</style>
